import { useEffect } from 'react';

export const useScrollLock = (isActive: boolean) => {
  useEffect(() => {
    if (!isActive) {
      return;
    }

    const previousValue = document.body.style.getPropertyValue('overflow');

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousValue;
    };
  }, [isActive]);
};
